import $ from "jquery";

/*------------------------------------*\
    HEADER
\*------------------------------------*/
class Header {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        self.shrink();

        if(window.innerWidth < 1360) {
            self.dropdowns();
            self.navToggle();
        }
    }

    shrink() {
        let self = this;

        // On page load
        var scrollStart = $(window).scrollTop();

        if(scrollStart >= 1) {
            $('.site-head').addClass('is-shrunk');
        }

        // On scroll
        $(window).on("scroll", function() {
            var scroll = $(window).scrollTop();

            if(scroll >= 1) {
                $('.site-head').addClass('is-shrunk');
            }
            else {
                $('.site-head').removeClass('is-shrunk');
            }
        });
    }

    navToggle() {
        let self = this;

        const toggle = document.querySelector('[data-nav-toggle]');
        const nav = document.querySelector('[data-nav]');

        toggle.addEventListener('click', evt => {
            evt.preventDefault();
            nav.classList.toggle('is-open');
            toggle.classList.toggle('is-open');
        });
    }

    dropdowns() {
        let self = this;

        const dropdowns = self.elem.querySelectorAll('[data-nav-dropdown]');

        dropdowns.forEach(elem => {
            let trigger = elem.querySelector('[data-nav-dropdown-trigger]');
            let dropdown = elem.querySelector('[data-nav-dropdown-menu]');

            trigger.addEventListener('click', evt => {
                evt.preventDefault();
                dropdown.classList.toggle('is-open');
                trigger.classList.toggle('is-active');
            });

            // Listen for clicks outside of this nav element and
            // close the dropdown
            document.addEventListener('click', evt => {
                if (!elem.contains(evt.target)) {
                    dropdown.classList.remove('is-open');
                    trigger.classList.remove('is-active');
                }
            });
        });
    }
}

export default Header;